<template>
  <div class="dropdown d-inline">
    <Button id="outOfStockFilter" color="primary" :title="$t('key_out_of_stock_filter_title')" class="dropdown-toggle ms-2 " :variant="optionSelected == '' ? 'outline' : 'fill'"
            data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-up-down me-1" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="outOfStockFilter">
      <li>
        <button class="dropdown-item border-radius-md text-error" :class="[optionSelected=='true'?'active-item':'']" type="button" @click="handleClick('true')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-triangle-exclamation me-3 text-error"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_out_of_stock_filter_option_yes') }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_clear_filters') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

import Button from "@/picko/generic_components/Button.vue";

export default {
  name: "OutOfStockFilter",
  components: {
    Button
  },
  props: {
    filterOutOfStock: {
      type: String,
      default: () => ''
    }
  },
  emits: ['out-of-stock-filter-change'],
  data() {
    return {
      optionSelected: this.filterOutOfStock
    }
  },
  watch: {
    filterOutOfStock() {
      this.optionSelected = this.filterOutOfStock;
    }
  },
  methods: {
    handleClick(newOption) {
      this.optionSelected = newOption;
      this.$emit('out-of-stock-filter-change', newOption);

      const dropdownElement = document.querySelector('.dropdown-menu.show');
      if (dropdownElement) {
        dropdownElement.classList.remove('show');
      }
    }
  }
}

</script>
